import { IResponse } from '@/types/common';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';

/** POST /uploads/video のレスポンス。サーバーが mp4 を解析した結果 */
export interface IUploadVideoResponse {
  url: string;
  durationSec: number | null;
  width: number | null;
  height: number | null;
  videoCodec: string | null;
  fileSizeBytes: number;
}

class Upload {
  /**
   * 動画は静止画と別のエンドポイントに送る。
   * サーバー側が mp4 の中身（faststart / コーデック / 映像データの有無）を
   * 検証したうえで、尺・解像度を解析して返す。表示面によらず共通。
   */
  uploadVideo = (file: File): Promise<IResponse<IUploadVideoResponse>> => {
    const formData = new FormData();
    formData.append('file', file);

    return axiosClient.post(ENDPOINT.UPLOAD.UPLOAD_VIDEO, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  };
}

export const UploadService = new Upload();
